import React from 'react';

export interface ITransactionItem {
  id: string | number;
  label: string;
  value: string;
}

export interface ITransactionItemsList {
  label: string;
  items: ITransactionItem[];
}

export const TransactionItems = (props: ITransactionItemsList) => {
  const { label, items } = props;
  return (
    <div className="transaction-items">
      <p className="label">{label}</p>
      {items.map((item: ITransactionItem) => (
        <div className="item" key={item.id}>
          <span className="label">{item.label}</span>
          <span className="value">{item.value}</span>
        </div>
      ))}
    </div>
  );
};
